import { render, staticRenderFns } from "./SettingsBilling.vue?vue&type=template&id=2b5b9fa2&scoped=true&"
import script from "./SettingsBilling.vue?vue&type=script&lang=js&"
export * from "./SettingsBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b9fa2",
  null
  
)

export default component.exports